export const dayNames = [
  'EAB.COMMON.SUNDAY',
  'EAB.COMMON.MONDAY',
  'EAB.COMMON.TUESDAY',
  'EAB.COMMON.WEDNESDAY',
  'EAB.COMMON.THURSDAY',
  'EAB.COMMON.FRIDAY',
  'EAB.COMMON.SATURDAY'
];
